module.exports = __webpack_public_path__ + "static/media/median-graph.6247f17c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/median-graph.png
// module id = ./src/assets/median-graph.png
// module chunks = 0